import globals from '@descope-ui/theme-globals';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { BadgeClass } from './component/BadgeClass';

const globalRefs = getThemeRefs(globals);

const vars = BadgeClass.cssVarList;

const badge = {
  [vars.hostWidth]: 'fit-content',
  [vars.hostDirection]: globalRefs.direction,

  [vars.textAlign]: 'center',

  [vars.fontFamily]: globalRefs.fonts.font1.family,
  [vars.fontWeight]: '400',

  [vars.verticalPadding]: '0.25em',
  [vars.horizontalPadding]: '0.5em',

  [vars.borderWidth]: globalRefs.border.xs,
  [vars.borderRadius]: globalRefs.radius.xs,
  [vars.borderColor]: 'transparent',
  [vars.borderStyle]: 'solid',

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },

  size: {
    xs: { [vars.fontSize]: '12px' },
    sm: { [vars.fontSize]: '14px' },
    md: { [vars.fontSize]: '16px' },
    lg: { [vars.fontSize]: '18px' },
  },

  mode: {
    default: {
      [vars.textColor]: globalRefs.colors.surface.dark,
      _bordered: {
        [vars.borderColor]: globalRefs.colors.surface.light,
      },
    },
    primary: {
      [vars.textColor]: globalRefs.colors.primary.main,
      _bordered: {
        [vars.borderColor]: globalRefs.colors.primary.light,
      },
    },
    secondary: {
      [vars.textColor]: globalRefs.colors.secondary.main,
      _bordered: {
        [vars.borderColor]: globalRefs.colors.secondary.light,
      },
    },
    error: {
      [vars.textColor]: globalRefs.colors.error.main,
      _bordered: {
        [vars.borderColor]: globalRefs.colors.error.light,
      },
    },
    success: {
      [vars.textColor]: globalRefs.colors.success.main,
      _bordered: {
        [vars.borderColor]: globalRefs.colors.success.light,
      },
    },
  },
};

export default badge;
export { vars };
